import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper"

// This controller is used to find emails of the selected or currently filtered leads.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      numberOfLeads: { type: Number, default: 0 },
      selectedLeadIds: { type: Array, default: [] },
      searchCallsLeft: { type: Number, default: 0 },
      searchOverageRequestsEnabled: { type: Boolean, default: false },
      singleCreditsBucket: { type: Boolean, default: false },
    }
  }

  static get targets() {
    return ["modalTitle", "modalText", "modalButton", "memberLearnMore"]
  }

  // This function is triggered using stimulus actions to submit a temporary form to find emails for the selected or
  // filtered leads.
  submit() {
    let formToSubmit = TempFormHelper.create("/lead/email_finder", "post", (form) => {
      if (this.selectedLeadIdsValue.length > 0) {
        this.selectedLeadIdsValue.forEach((leadId) => {
          TempFormHelper.addHiddenInput(form, "lead_ids[]", leadId)
        })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => {
          TempFormHelper.addHiddenInput(form, key, value)
        })
      }
    })

    formToSubmit.dataset.confirmDialogId = "confirm-leads-find-emails"

    const descriptionKey = this.singleCreditsBucketValue ? "description_unified" : "description"
    if (this._numberOfLeadsToSearch() > this.searchCallsLeftValue && this.searchOverageRequestsEnabledValue) {
      formToSubmit.dataset.turboConfirm = "true"

      this.modalTitleTarget.innerText = i18n.t("js.back.lead_actions.find_emails.overage.title", {
        count: this._numberOfLeadsToSearch(),
      })
      this.modalTextTarget.innerText = i18n.t(`js.back.lead_actions.find_emails.overage.${descriptionKey}`, {
        count: this._numberOfLeadsToSearch(),
        leads: CurrencyHelper.numberWithDelimiter(this._numberOfLeadsToSearch()),
      })
      this.modalButtonTarget.innerText = i18n.t("js.back.lead_actions.find_emails.overage.confirm_button", {
        count: this._numberOfLeadsToSearch(),
      })
    } else if (this._numberOfLeadsToSearch() > 1) {
      formToSubmit.dataset.turboConfirm = "true"

      this.modalTitleTarget.innerText = i18n.t("js.back.lead_actions.find_emails.verify.title", {
        count: this._numberOfLeadsToSearch(),
      })
      this.modalTextTarget.innerText = i18n.t(`js.back.lead_actions.find_emails.verify.${descriptionKey}`, {
        count: this._numberOfLeadsToSearch(),
        leads: CurrencyHelper.numberWithDelimiter(this._numberOfLeadsToSearch()),
      })
      this.modalButtonTarget.innerText = i18n.t("js.back.lead_actions.find_emails.verify.confirm_button", {
        count: this._numberOfLeadsToSearch(),
      })
    }

    formToSubmit.addEventListener("turbo:submit-end", () => {
      this.searchCallsLeftValue -= this._numberOfLeadsToSearch()
    })
    formToSubmit.requestSubmit()
  }

  _numberOfLeadsToSearch() {
    if (this.selectedLeadIdsValue.length > 0) {
      return this.selectedLeadIdsValue.length
    } else {
      return this.numberOfLeadsValue
    }
  }

  // This function is triggered using stimulus actions to update the selected leads value.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets
        .map((dataSet) => dataSet.leadId || dataSet.recordId)
        .filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
